/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, input, output } from '@angular/core';
import { ControlValueAccessor, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DialogService } from '@shared/component.dialog';
import { PickHourModal, PickHourModalResult } from './components/pick-hour-modal/pick-hour-modal';
import { TimePickerComponent } from './components/time-picker/time-picker.component';


@Component({
  selector: 'pick-hour',
  templateUrl: './pick-hour.component.html',
  styleUrls: ['./pick-hour.component.scss'],
  imports: [ReactiveFormsModule],
  standalone: true
})
export class PickHourComponent implements ControlValueAccessor {
  placeholder = input<string>();
  label = input<string>();
  time = input<PickHourModal>();
  timeSelected = output<string>();

  control: FormControl = new FormControl('');

  readonly dialog = inject(DialogService);

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  openPickHourModal() {
   const dialogRef = this.dialog.open(TimePickerComponent, {
      backdropClose: true,
      data: this.time()
    });

    dialogRef.instance().timeSelected.subscribe({
      next: (res: PickHourModalResult) => {
        this.timeSelected.emit(res.hour + res.minute);
        this.control.setValue(`${res.hour}:${res.minute} ${res.period} WIB`);
        dialogRef.close();
      }
    });
  }
}
